import React from "react";
import { InfoCardNew, LogoLoader } from "../../../components";

const raMetrics = ["Accounts", "Completed Accounts", "Contacts"];
const formatRaMetrics = {
  Accounts: "accounts",
  "Completed Accounts": "completedAccounts",
  Contacts: "contacts"
}
const bdmMetrics = ["Positives", "Jobs Opened", "Joined", "Backout"];
const formatBdmMetrics = {
  Positives: "positives",
  "Jobs Opened": "jobsOpened",
  Joined: "joined",
  Backout: "backout"
}
const recruiterMetrics = ["Active Jobs", "Internal Submissions", "Client Submissions"];
const formatRecruiterMetrics = {
  "Active Jobs": "activeJobs",
  "Internal Submissions": "internalSubmissions",
  "Client Submissions": "clientSubmissions"
}

const InfoDataCardReports = ({
  activeButton,
  metrics,
  teamMetrics,
  roleType,
  compareMetrics,
  compareTeamMetrics,
  loading
}) => {
  const infoDataCardReports = roleType === 2 ? raMetrics : roleType === 3 ? bdmMetrics : roleType === 4 ? recruiterMetrics : [];

  const length = infoDataCardReports.length;

  const shouldShowLoader =
    loading &&
    (
      (activeButton === "myPerformance" && !metrics) ||
      (activeButton === "myTeamPerformance" && !teamMetrics)
    );

  if (shouldShowLoader) {
    return (
      <div className="flex justify-center items-center h-20">
        <LogoLoader />
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-${length} gap-5`}>
      {infoDataCardReports.map((item) => (
        <InfoCardNew
          key={item}
          title={item}
          value={
            activeButton === "myPerformance"
              ? roleType === 2 ? metrics[formatRaMetrics[item]] || 0 
                : roleType === 3 ? metrics[formatBdmMetrics[item]] || 0
                : roleType === 4 ? metrics[formatRecruiterMetrics[item]] || 0
                : 0
              : roleType === 2 ? teamMetrics[formatRaMetrics[item]] || 0 
                : roleType === 3 ? teamMetrics[formatBdmMetrics[item]] || 0
                : roleType === 4 ? teamMetrics[formatRecruiterMetrics[item]] || 0
                : 0
          }
          backValue={
            activeButton === "myPerformance"
              ? roleType === 2 ? compareMetrics[formatRaMetrics[item]] || 0 
                : roleType === 3 ? compareMetrics[formatBdmMetrics[item]] || 0
                : roleType === 4 ? compareMetrics[formatRecruiterMetrics[item]] || 0
                : 0
              : roleType === 2 ? compareTeamMetrics[formatRaMetrics[item]] || 0 
                : roleType === 3 ? compareTeamMetrics[formatBdmMetrics[item]] || 0
                : roleType === 4 ? compareTeamMetrics[formatRecruiterMetrics[item]] || 0
                : 0
          }
        />
      ))}
    </div>
  );
};

export default InfoDataCardReports;
